
import React from "react";

function ContainerLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <symbol id="container-icon" viewBox="0 0 51.113 35.786">
        <g fill="#166DE7">
          <path
            d="M109.5 281.754a3.907 3.907 0 01.836-1.222c1.139-1.437 2.292-2.863 3.436-4.3a1.063 1.063 0 01.913-.44c.622.015 1.245 0 1.867 0a1.045 1.045 0 011.133 1.016h34.736c.019-.093.031-.189.058-.28a1.012 1.012 0 01.97-.733 87.043 87.043 0 012.044 0 1.035 1.035 0 01.832.416c1.3 1.641 2.6 3.287 3.924 4.914a1.583 1.583 0 01.364 1.073q-.009 14.119 0 28.237a1.026 1.026 0 01-.6 1.04 1.267 1.267 0 01-.5.092c-.966.008-1.932 0-2.9 0a1.018 1.018 0 01-1.1-.92.162.162 0 00-.1-.092.429.429 0 00-.144 0h-40.645c-.017.093-.027.177-.048.258a.992.992 0 01-.934.752q-1.586.016-3.171 0a.988.988 0 01-.922-.705c-.015-.045-.032-.089-.049-.134zm2.057 1.214v26.569h.981a2.745 2.745 0 01.14-.448 1.06 1.06 0 011.046-.578h42.664a.643.643 0 01.176 0 2.347 2.347 0 01.524.18.984.984 0 01.464.833h1.014v-26.552h-1.016a1.082 1.082 0 01-.28.68 1.153 1.153 0 01-.92.331h-42.793a1.009 1.009 0 01-.949-.735c-.025-.087-.037-.177-.056-.273zm3.073-1.029h40.625a.624.624 0 01.1 0c.119.019.153-.034.167-.149a1.007 1.007 0 01.979-.874h.837c.039 0 .078-.007.118-.011v-.029q-1.18-1.476-2.363-2.95a.187.187 0 00-.116-.071c-.159-.008-.319 0-.467 0a2.665 2.665 0 01-.1.374 1.058 1.058 0 01-1.082.646h-36.527c-.064 0-.129 0-.193-.005a1.01 1.01 0 01-.953-.886c-.006-.04-.018-.08-.028-.127-.116 0-.224.008-.33 0a.333.333 0 00-.322.15c-.74.932-1.487 1.859-2.231 2.787-.028.035-.05.075-.086.13h.956a1.011 1.011 0 01.96.722c.028.092.042.187.066.3z"
            transform="translate(0 -167.212) translate(-109.5 -108.584)"
          ></path>
          <path
            d="M1111.507 523.675v9.143a1.038 1.038 0 01-.763 1.078 1.021 1.021 0 01-1.283-.967v-18.384a1.03 1.03 0 01.762-1.062 1.009 1.009 0 011.285.935v.193z"
            transform="translate(0 -167.212) translate(-1066.526 -336.03)"
          ></path>
          <path
            d="M825.812 523.721v9.127a1.047 1.047 0 01-.511.974 1.016 1.016 0 01-1.523-.749 1.863 1.863 0 01-.014-.24v-18.254a1.025 1.025 0 01.775-1.065 1.007 1.007 0 011.271.936v.225l.002 9.046z"
            transform="translate(0 -167.212) translate(-793.098 -336.061)"
          ></path>
          <path
            d="M540.042 523.452v9.111a1.037 1.037 0 01-.6 1.032 1.013 1.013 0 01-1.435-.793 1.97 1.97 0 01-.015-.241v-18.238a1.043 1.043 0 01.394-.891.97.97 0 011.072-.131.986.986 0 01.583.943q.003 4.604.001 9.208z"
            transform="translate(0 -167.212) translate(-519.596 -335.791)"
          ></path>
          <path
            d="M254.38 523.695v9.175a1.021 1.021 0 01-2.029.209 2.406 2.406 0 01-.016-.289v-18.173a1.033 1.033 0 01.775-1.114 1.007 1.007 0 011.269.921v.161l.001 9.11z"
            transform="translate(0 -167.212) translate(-246.202 -336.051)"
          ></path>
          <path
            d="M395.221 523.6v-9.207a1.015 1.015 0 01.772-1 .975.975 0 011.119.452 1.571 1.571 0 01.14.422 1.194 1.194 0 01.011.272v18.124a1.106 1.106 0 01-.406.966.969.969 0 01-1.03.121.992.992 0 01-.607-.878c-.005-.059 0-.118 0-.177z"
            transform="translate(0 -167.212) translate(-382.953 -335.944)"
          ></path>
          <path
            d="M683.029 523.621v9.078a1.058 1.058 0 01-.5 1 .964.964 0 01-1.024.015.987.987 0 01-.52-.852V514.413a1.034 1.034 0 011.153-1.051 1.009 1.009 0 01.876.891c.009.1.01.2.01.305q.006 4.532.005 9.063z"
            transform="translate(0 -167.212) translate(-656.453 -335.944)"
          ></path>
          <path
            d="M968.777 523.533v9.126a1.052 1.052 0 01-.509.99 1.016 1.016 0 01-1.529-.858v-18.494a1.035 1.035 0 011-1 1.014 1.014 0 011.028.946v.241q.011 4.526.01 9.049z"
            transform="translate(0 -167.212) translate(-929.935 -335.891)"
          ></path>
        </g>
      </symbol>
      <use xlinkHref="#container-icon"></use>
    </svg>
  );
}

export default ContainerLogo;